import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {ISurveyPropertyDetails} from "../../types/IBuildSurveyParams";

export const mapPropertyDetailsToSurveyPropertyDetails = (property: IPropertyDetail | null | undefined): ISurveyPropertyDetails | null => {
    if (!property) {
        return null;
    }

    return {
        id: property.id,
        price: property.price,
        price_m2: property.price_m2,
        rooms: property.rooms,
        offer: property.offer
            ? {
                  region: {
                      id: property.offer.region.id,
                      type: property.offer.region.type,
                      stats: property.offer.region.stats
                          ? {
                                region_type_district: property.offer.region.stats.region_type_district,
                                region_type_county: property.offer.region.stats.region_type_county
                            }
                          : undefined
                  }
              }
            : undefined
    };
};
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {ISurveyPropertyDetails} from "../../types/IBuildSurveyParams";

export const mapPropertyDetailsToSurveyPropertyDetails = (property: IPropertyDetail | null | undefined): ISurveyPropertyDetails | null => {
    if (!property) {
        return null;
    }

    return {
        id: property.id,
        price: property.price,
        price_m2: property.price_m2,
        rooms: property.rooms,
        offer: property.offer
            ? {
                  region: {
                      id: property.offer.region.id,
                      type: property.offer.region.type,
                      stats: property.offer.region.stats
                          ? {
                                region_type_district: property.offer.region.stats.region_type_district,
                                region_type_county: property.offer.region.stats.region_type_county
                            }
                          : undefined
                  }
              }
            : undefined
    };
};
